<div class="email-signup-wrapper">
  <i2g-form-master *ngIf="form" [form]="form">
    <i2g-input-field
      class="form-row"
      e2eId="email-address"
      fieldId="emailAddress"
      layoutDirection="column"
      [fieldControl]="emailAddress"
      [label]="'FORM.EMAIL_ADDRESS.LABEL' | translate"
    >
    </i2g-input-field>

    <i2g-input-field
      class="form-row"
      type="password"
      e2eId="password"
      fieldId="password"
      layoutDirection="column"
      [fieldControl]="password"
      [errorMessages]="passwordErrorMessage"
      [label]="'FORM.PASSWORD.LABEL' | translate"
    >
    </i2g-input-field>

    <div *ngIf="showLegalNote" class="legal-note-wrapper">
      <span
        *ngIf="legalNote; else legalNotePlaceholder"
        class="legal-note"
        e2eId="legal-note"
        [innerHTML]="legalNote | translate | safe: 'html'"
      >
      </span>
    </div>

    <ng-template #legalNotePlaceholder>
      <div class="terms-placeholder-line shimmer"></div>
      <div class="terms-placeholder-line shimmer"></div>
    </ng-template>

    <button
      class="signup-action"
      e2eId="signup-action"
      i2gButton
      buttonStyle="emphasis"
      [disabled]="processing"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (click)="submit()"
    >
      <i2g-icon *ngIf="processing" class="loading-icon" [icon]="spinnerIcon">
      </i2g-icon>
      {{
        (processing ? 'SIGNUP.CREATING_ACCOUNT' : 'ACTION.SIGN_UP') | translate
      }}
    </button>
  </i2g-form-master>
</div>
